import { defineElement, html, TemplateElement } from '@webtides/element-js';

class ImageElement extends TemplateElement {
    properties() {
        return {
            image: null,
            altText: null,
            caption: null,
        };
    }
    injectProperties() {
        return { environment: null };
    }

    get damUrl() {
        if (!this.image) {
            return '#';
        }
        const imageLink = this.image?.['@link'];
        return imageLink?.startsWith('https') ? `${imageLink}` : `${this.environment?.mgnlBaseUrl}${imageLink}`;
    }

    template() {
        return html`
            <div>
                <img src="${this.damUrl}" alt="${this.altText}" />
                ${this.caption ? html`<div v-if="caption" class="text-center">${this.caption}</div>` : null}
            </div>
        `;
    }
}

defineElement('image-element', ImageElement);
